/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { dataExportsUpdateRoute } from "../funcs/dataExportsUpdateRoute.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { DataExportRoute } from "../models/components/dataexportroute.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  UpdateDataExportRouteRequest,
  UpdateDataExportRouteSecurity,
} from "../models/operations/updatedataexportroute.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type UpdateDataExportRouteMutationVariables = {
  request: UpdateDataExportRouteRequest;
  security?: UpdateDataExportRouteSecurity | undefined;
  options?: RequestOptions;
};

export type UpdateDataExportRouteMutationData = DataExportRoute;

export type UpdateDataExportRouteMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * updateRoute dataExports
 *
 * @remarks
 * Replace the selected data source's export route configuration.
 */
export function useUpdateDataExportRouteMutation(
  options?: MutationHookOptions<
    UpdateDataExportRouteMutationData,
    UpdateDataExportRouteMutationError,
    UpdateDataExportRouteMutationVariables
  >,
): UseMutationResult<
  UpdateDataExportRouteMutationData,
  UpdateDataExportRouteMutationError,
  UpdateDataExportRouteMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildUpdateDataExportRouteMutation(client, options),
    ...options,
  });
}

export function mutationKeyUpdateDataExportRoute(): MutationKey {
  return ["@gram/client", "dataExports", "updateRoute"];
}

export function buildUpdateDataExportRouteMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: UpdateDataExportRouteMutationVariables,
  ) => Promise<UpdateDataExportRouteMutationData>;
} {
  return {
    mutationKey: mutationKeyUpdateDataExportRoute(),
    mutationFn: function updateDataExportRouteMutationFn({
      request,
      security,
      options,
    }): Promise<UpdateDataExportRouteMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(dataExportsUpdateRoute(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
